// store.js
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

// 定义一个持久化插件
const createPersistedState = () => {
  return (store) => {
    // 在 store 初始化之后调用
    store.subscribe((mutation, state) => {
      try {
        const stateToSave = JSON.stringify(state);
        localStorage.setItem("vuexState", stateToSave);
      } catch (e) {
        console.error("Could not save state to localStorage:", e);
      }
    });

    // 在 store 实例化时调用，从 localStorage 恢复 state
    const savedState = JSON.parse(localStorage.getItem("vuexState"));
    if (savedState) {
      store.replaceState(Object.assign(store.state, savedState));
    }
  };
};

export default new Vuex.Store({
  state: {
    // 定义你的 state
    historyData: [],
    timeData: 1740389138,
    referenceData: [],
  },
  mutations: {
    // 定义你的 mutations
    SET_HISTORY_DATA(state, payload) {
      state.historyData = payload;
    },
    // 定义你的 mutations
    SET_TIME_DATA(state, payload) {
      state.timeData = payload;
    },

    // 定义你的 mutations
    SET_REFERENCE_DATA(state, payload) {
      state.referenceData = payload;
    },
  },
  actions: {
    // 定义你的 actions（可选）
    updateHistoryData({ commit }, payload) {
      commit("SET_HISTORY_DATA", payload);
    },
    updateTimeData({ commit }, payload) {
      commit("SET_TIME_DATA", payload);
    },
    updateReferenceData({ commit }, payload) {
      commit("SET_REFERENCE_DATA", payload);
    },
  },
  getters: {
    // 定义你的 getters（可选）
    getHistoryData: (state) => state.historyData,
    getTimeData: (state) => state.historyData,
    getReferenceData: (state) => state.referenceData,
  },
  plugins: [createPersistedState()], // 应用持久化插件
});



// WEBPACK FOOTER //
// ./src/store/index.js